import { GuardedDeletionService, PlantationTypeService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardBodyComponent,
  CardComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import {
  PlantationTypeCreateDto,
  PlantationTypeDto,
  PlantationTypeExcelDownloadDto,
  PlantationTypeUpdateDto,
} from '../proxy/planning/dtos/plantation-type';
import { PLANTATIONTYPE_CONFIG, PLANTATIONTYPE_FIELDS } from './plantation-type.config';
import { Component, inject } from '@angular/core';

@Component({
  selector: 'app-plantation-type',
  imports: [CardComponent, CardBodyComponent, CrudPage, GenericForm],
  providers: [ListService, PlantationTypeService, ConfirmationService],
  templateUrl: './plantation-type.html',
  styleUrl: './plantation-type.scss',
})
export class PlantationType extends BaseCrudComponent<
  PlantationTypeDto,
  PlantationTypeCreateDto,
  PlantationTypeUpdateDto,
  PlantationTypeExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(PlantationTypeService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('PlantationType', ids),
  };
  config = PLANTATIONTYPE_CONFIG;
  fields = PLANTATIONTYPE_FIELDS;

  protected prepareUpdateDto(
    data: any,
    selected: PlantationTypeDto
  ): PlantationTypeUpdateDto {
    return {
      name: data.name,
      code: data.code,
      isRotationType: data.isRotationType,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'PlantationType';
  }
}
